import type { PaymentType } from '#src/app/shared/utils/payments';

import type { ContributionsPageMessageTypes, ContributionsPageState, PaymentMethod } from './types';

export const mutations = {
	setContributionsFormLoading: (state: ContributionsPageState): ContributionsPageState => ({
		...state,
		subscription: {
			...state.subscription,
			formState: { status: 'loading' },
		},
	}),
	clearContributionsFormLoading: (state: ContributionsPageState): ContributionsPageState => ({
		...state,
		subscription: {
			...state.subscription,
			formState: null,
		},
	}),
	setContributionsFormError: (state: ContributionsPageState, error: string): ContributionsPageState => ({
		...state,
		subscription: {
			...state.subscription,
			formState: { status: 'error', error },
		},
	}),
	clearContributionsFormError: (state: ContributionsPageState): ContributionsPageState => ({
		...state,
		subscription: {
			...state.subscription,
			formState: null,
		},
	}),
	setContributionsFormValidationErrors: (
		state: ContributionsPageState,
		validationErrors: ContributionsPageState['subscription']['validationErrors'],
	): ContributionsPageState => ({
		...state,
		subscription: {
			...state.subscription,
			validationErrors,
		},
	}),
	setContributionAmount: (state: ContributionsPageState, amount: number): ContributionsPageState => ({
		...state,
		subscription: {
			...state.subscription,
			unsavedAmount: amount,
		},
	}),
	handleContributionsUpdateSuccess: (
		state: ContributionsPageState,
		{
			amount,
			message,
		}: {
			amount: number;
			message: string;
		},
	): ContributionsPageState => {
		return {
			...state,
			subscription: {
				...state.subscription,
				amount,
				formState: null,
			},
			pageMessage: { message, severity: 'success' },
		};
	},
	setPageMessage: (
		state: ContributionsPageState,
		pageMessage: {
			message: string;
			severity: ContributionsPageMessageTypes;
		},
	): ContributionsPageState => {
		return {
			...state,
			pageMessage,
		};
	},
	resetPageMessage: (state: ContributionsPageState): ContributionsPageState => {
		return {
			...state,
			nameErrorMessage: undefined,
			pageMessage: null,
		};
	},
	setSelectedPaymentType: (state: ContributionsPageState, selectedPaymentType: PaymentType): ContributionsPageState => {
		return {
			...state,
			selectedPaymentType,
		};
	},
	setLoadingUpdatePaymentMethod: (state: ContributionsPageState, loading: boolean): ContributionsPageState => {
		return {
			...state,
			loadingUpdatePaymentMethod: loading,
		};
	},
	handlePaymentUpdateSuccess: (
		state: ContributionsPageState,
		{
			paymentMethod,
			message,
		}: {
			paymentMethod: PaymentMethod;

			message: string;
		},
	): ContributionsPageState => {
		return {
			...state,
			loadingUpdatePaymentMethod: false,
			subscription: {
				...state.subscription,
				paymentMethod,
			},
			pageMessage: { message, severity: 'success' },
			userName: '',
			pmUpdatedAt: Date.now(),
		};
	},
	handlePaymentUpdateError: (
		state: ContributionsPageState,
		{
			message,
		}: {
			message?: string;
		},
	): ContributionsPageState => {
		return {
			...state,
			loadingUpdatePaymentMethod: false,
			pageMessage: message ? { message, severity: 'critical' } : null,
		};
	},
	setNameErrorMessage: (
		state: ContributionsPageState,
		nameErrorMessage: string | undefined,
	): ContributionsPageState => {
		return {
			...state,
			nameErrorMessage,
		};
	},
	setUserName: (state: ContributionsPageState, userName: string): ContributionsPageState => {
		return {
			...state,
			userName,
		};
	},
};
